/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetReportsParams, ReportDto, ReportRequest } from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';
import { customAxiosResponse } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getReportById = (
  userId: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ReportDto>(
    { url: `/api/${userId}/reports/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetReportByIdQueryKey = (userId: string, id: number) => {
  return [`/api/${userId}/reports/${id}`] as const;
};

export const getGetReportByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReportByIdQueryKey(userId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportById>>> = ({
    signal,
  }) => getReportById(userId, id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportById>>
>;
export type GetReportByIdQueryError = ErrorType<unknown>;

export function useGetReportById<
  TData = Awaited<ReturnType<typeof getReportById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportById>>,
          TError,
          Awaited<ReturnType<typeof getReportById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportById<
  TData = Awaited<ReturnType<typeof getReportById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportById>>,
          TError,
          Awaited<ReturnType<typeof getReportById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportById<
  TData = Awaited<ReturnType<typeof getReportById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetReportById<
  TData = Awaited<ReturnType<typeof getReportById>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReportByIdQueryOptions(userId, id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const updateReport = (
  userId: string,
  id: number,
  reportRequest: BodyType<ReportRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ReportDto>(
    {
      url: `/api/${userId}/reports/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: reportRequest,
      signal,
    },
    options
  );
};

export const getUpdateReportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReport>>,
    TError,
    { userId: string; id: number; data: BodyType<ReportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReport>>,
  TError,
  { userId: string; id: number; data: BodyType<ReportRequest> },
  TContext
> => {
  const mutationKey = ['updateReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReport>>,
    { userId: string; id: number; data: BodyType<ReportRequest> }
  > = (props) => {
    const { userId, id, data } = props ?? {};

    return updateReport(userId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReport>>
>;
export type UpdateReportMutationBody = BodyType<ReportRequest>;
export type UpdateReportMutationError = ErrorType<unknown>;

export const useUpdateReport = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateReport>>,
      TError,
      { userId: string; id: number; data: BodyType<ReportRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateReport>>,
  TError,
  { userId: string; id: number; data: BodyType<ReportRequest> },
  TContext
> => {
  return useMutation(getUpdateReportMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const deleteReport = (
  userId: string,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    { url: `/api/${userId}/reports/${id}`, method: 'DELETE', signal },
    options
  );
};

export const getDeleteReportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReport>>,
    TError,
    { userId: string; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReport>>,
  TError,
  { userId: string; id: number },
  TContext
> => {
  const mutationKey = ['deleteReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReport>>,
    { userId: string; id: number }
  > = (props) => {
    const { userId, id } = props ?? {};

    return deleteReport(userId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReport>>
>;

export type DeleteReportMutationError = ErrorType<unknown>;

export const useDeleteReport = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReport>>,
      TError,
      { userId: string; id: number },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReport>>,
  TError,
  { userId: string; id: number },
  TContext
> => {
  return useMutation(getDeleteReportMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_CLIENT_SERVICE, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN**<br /><br />
 */
export const getReports = (
  userId: string,
  params?: GetReportsParams,
  options?: SecondParameter<typeof customAxiosResponse>,
  signal?: AbortSignal
) => {
  return customAxiosResponse<ReportDto[]>(
    { url: `/api/${userId}/reports`, method: 'GET', params, signal },
    options
  );
};

export const getGetReportsQueryKey = (
  userId: string,
  params?: GetReportsParams
) => {
  return [`/api/${userId}/reports`, ...(params ? [params] : [])] as const;
};

export const getGetReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReportsQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReports>>> = ({
    signal,
  }) => getReports(userId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReports>>
>;
export type GetReportsQueryError = ErrorType<unknown>;

export function useGetReports<
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params: undefined | GetReportsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReports>>,
          TError,
          Awaited<ReturnType<typeof getReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReports<
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReports>>,
          TError,
          Awaited<ReturnType<typeof getReports>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReports<
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetReports<
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = ErrorType<unknown>
>(
  userId: string,
  params?: GetReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosResponse>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReportsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN**<br /><br />
 */
export const createReport = (
  userId: string,
  reportRequest: BodyType<ReportRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ReportDto>(
    {
      url: `/api/${userId}/reports`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: reportRequest,
      signal,
    },
    options
  );
};

export const getCreateReportMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReport>>,
    TError,
    { userId: string; data: BodyType<ReportRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReport>>,
  TError,
  { userId: string; data: BodyType<ReportRequest> },
  TContext
> => {
  const mutationKey = ['createReport'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReport>>,
    { userId: string; data: BodyType<ReportRequest> }
  > = (props) => {
    const { userId, data } = props ?? {};

    return createReport(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createReport>>
>;
export type CreateReportMutationBody = BodyType<ReportRequest>;
export type CreateReportMutationError = ErrorType<unknown>;

export const useCreateReport = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createReport>>,
      TError,
      { userId: string; data: BodyType<ReportRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createReport>>,
  TError,
  { userId: string; data: BodyType<ReportRequest> },
  TContext
> => {
  return useMutation(getCreateReportMutationOptions(options), queryClient);
};
